<template>
    <div class="wrap">
          <p @click="changeBack" v-if="step == 1">
              Hello
          </p>
          <p @click="changeBack" v-if="step == 2" >
              Welcome to MSData
          </p>
          <div>
            <!-- <el-button type="primary" @click="toIndex">开启旅程</el-button> -->
            <p @click="changeBack" v-if="step == 3">
              Click Start journey
           </p>
          </div>
          
        <css-doodle>
            :doodle {
            	@grid: 1x8 / 100vmin;
            }
            @place-cell: center;
              @nth(8) {
                position: absolute;
                top: 0;
                left: 0;
                right: 0;
                bottom: 0;
                backdrop-filter: blur(@rand(70px, 160px));
                width: 200vmax;
                height: 200vmax;
                z-index: 1;
              }
              @nth(n - 1) {
                position: relative;
                top: @rand(-80%, 80%);
                left: @rand(-80%, 80%);
                width: @rand(40vmin, 80vmin);
                height: @rand(40vmin, 80vmin);
                transform: translate(@rand(-200%, 200%), @rand(-60%, 60%)) scale(@rand(.8, 1.8)) skew(@rand(45deg));
                clip-path: polygon(
                  @r(0, 30%) @r(0, 50%), 
                  @r(30%, 60%) @r(0%, 30%), 
                  @r(60%, 100%) @r(0%, 50%), 
                  @r(60%, 100%) @r(50%, 100%), 
                  @r(30%, 60%) @r(60%, 100%),
                  @r(0, 30%) @r(60%, 100%)
                );
                background: @pick(#f44336, #e91e63, #9c27b0, #673ab7, #3f51b5, #60569e, #e6437d, #ebbf4d, #00bcd4, #03a9f4, #2196f3, #009688, #5ee463, #f8e645, #ffc107, #ff5722, #43f8bf);
                <!-- background: @pick(#5277F7, #4868DC, #3A54B7, #31479D, #283A85, #24347A, #24347A, #405DC5, #00bcd4); -->
                opacity: @rand(.3, .8);
                animation: colorChange @rand(6.1s, 16.1s) infinite @rand(-.5s, -2.5s) linear alternate;
              }

              @keyframes colorChange {
                100% {
                  left: 0;
                  top: 0;
                  filter: hue-rotate(360deg);
                }
              }
        </css-doodle>
    </div>
</template>

<script>
import importCSSDoodle from 'css-doodle'
    export default {
        data(){
            return{
                step:1,
            }
        },
        created(){
            // let url = document.location.href;
        },
        mounted(){
            this.startAnimal()
        },
        methods: {
            changeBack(){
                const doodle = document.querySelector('css-doodle');
                doodle.update();
            },

            //去数据平台首页
            toIndex(){
              this.$router.push('/index')
            },

            //开启动画
            startAnimal(){
              let outTime = setInterval(() =>{
                if(this.step < 3){
                  this.step++
                }else{
                  clearTimeout(outTime)
                }
              },2500)
            }
        }
    }
</script>

<style lang="scss" scoped>
.wrap{
    position: relative;
    margin: 0;
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
    background-color: #fff;
    
    p{  
      position: fixed;
      text-align: center;
      height: 150px;
      width: 1000px;
      top: calc(50vh - 75px);
      left:calc(50vw - 500px);
      font-size: 80px;
      font-weight: bold;
      color: #5277F7;
      z-index: 10;
      animation: anim 2.5s;
    }
}

@keyframes anim{
  0% {
    opacity: 0;
  }

  80% {
    opacity: 1;
  }

  100%{
    opacity: 0.6;
  }
}

</style>

